import { isMobile } from "../../../common/utils";
import { AllieChecklistDesktop } from "./Checklist.desktop";
import { AllieChecklistMobile } from "./Checklist.mobile";

export interface AllieChecklistItemProps {
  id?: number;
  title?: string;
  description?: string;
  assignedToUid?: number | null;
  isDone?: boolean;
  isRequired?: boolean;
}

export interface AllieChecklistProps {
  title?: string;
  titleMaxWidth?: number;
  description?: string;
  addItemText?: string;
  addItemTitlePlaceholder?: string;
  emptyChecklistText?: string;
  descriptionText?: string;
  descriptionPlaceholder?: string;
  addItemDisabled?: boolean;
  items: AllieChecklistItemProps[];
  operators?: { value: number; text: string }[];
  loggedUser?: { id: number; name: string; avatar?: string; };
  itemEditDisabled?: boolean;
  itemRemoveDisabled?: boolean;
  itemActionEditText?: string;
  itemActionRemoveText?: string;
  removeConfirmationTitle?: string;
  removeCancelText?: string;
  removeConfirmText?: string;
  onCreateItem?: (item: AllieChecklistItemProps) => Promise<unknown>;
  onEditItem?: (item: AllieChecklistItemProps) => Promise<unknown>;
  onRemoveItem?: (itemId: number) => Promise<unknown>;
  onDraftChange?: (items: AllieChecklistItemProps[]) => void;
}

export interface AllieChecklistItemProps {
  id?: number;
  title?: string;
  description?: string;
  assignedToUid?: number | null;
  isDone?: boolean;
  isRequired?: boolean;
}

export const AllieChecklist: React.FC<AllieChecklistProps> = (props) => {
  const ChecklistPlatform =  isMobile ? AllieChecklistMobile : AllieChecklistDesktop;

  return <ChecklistPlatform {...props} />
};
